import { render } from "./blog.vue?vue&type=template&id=38ced5d7&scoped=true&lang=html"
import script from "./blog.vue?vue&type=script&lang=js"
export * from "./blog.vue?vue&type=script&lang=js"

import "./blog.vue?vue&type=style&index=0&id=38ced5d7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ced5d7"]])

export default __exports__